// The config format:
// const config = [
//   { path: "/01-step/" },
//   { path: "/02-step/", skipCount: true },
// ]

export default (config) => (activeStepPath) => ({
  progressWidth: null,
  progressStep: null,
  totalSteps: null,

  init() {
    this.pageState = Alpine.store("pageState")

    this.progressStep = this.getProgressStep(activeStepPath)
    this.totalSteps = this.getTotalSteps()
    this.progressWidth = this.getProgressWidth()
  },

  getProgressStep(activeStepPath) {
    // TODO: the `activeStepPath` argument is kept for backward compatibility.
    // Future pipes should rely on the shared `this.pageState.activeStepFileSlug`
    const activePath = activeStepPath || this.pageState.activeStepFileSlug
    
    // Calculations based on actual pages files slugs used in dev (and not path names defined by product)
    const currentStepIndex = config.findIndex((step) => step.path === activePath)

    return config
      .slice(0, currentStepIndex + 1) // Get all previous steps including the current one
      .filter((step) => !step.skipCount).length // Filter out the steps that should not be counted
  },

  getTotalSteps() {
    return config.filter((step) => !step.skipCount).length // Filter out the steps that should not be counted
  },

  getProgressWidth() {
    return (this.progressStep * 100) / this.totalSteps
  },
})
